import {
  makeEnvironmentProviders,
  type EnvironmentProviders,
} from '@angular/core';
import { defaultsDeep } from 'lodash-es';

import {
  TREE_TABLE_CONFIG,
  TREE_TABLE_USER_CONFIG,
  TreeTableConfig,
  type IData,
  type ITreeTableConfig,
} from './tree-table.config';

export function userConfigFactory<T, U extends IData<T>>(
  userConfig: U,
): TreeTableConfig<T> {
  return defaultsDeep(userConfig, new TreeTableConfig());
}

export function provideTreeTableConfig(
  config: ITreeTableConfig = new TreeTableConfig(),
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: TREE_TABLE_USER_CONFIG,
      useValue: config,
    },
    {
      provide: TREE_TABLE_CONFIG,
      useFactory: userConfigFactory,
      deps: [TREE_TABLE_USER_CONFIG],
    },
  ]);
}
